import { formatMoney } from "@/lib/format";
import { DialogShell } from "./DialogShell";
import "./EmployeeFormDialog.css";
import "./PrintChecksDialog.css";

/** "1 check" / "3 checks". */
export function checkCount(n: number): string {
  return `${n} ${n === 1 ? "check" : "checks"}`;
}

/**
 * ef-062-7 - the confirm step before a batch prints. Same shell as the other dialogs (focus in,
 * Tab trapped, Escape / overlay / Cancel close). Printing numbers real checks and cannot be taken
 * back, so while the request is in flight both buttons are disabled and every way out is ignored.
 * The count and total are the server's, passed in.
 */
export function PrintChecksDialog({
  count,
  total,
  printing,
  onCancel,
  onConfirm,
}: {
  count: number;
  total: number;
  printing: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {

  return (
    <DialogShell
      title="Print unprinted checks"
      onClose={onCancel}
      busy={printing}
      dataState={printing ? "printing" : "confirming"}
      footer={
        <>
          <button type="button" className="btn btn--ghost" onClick={onCancel} disabled={printing}>
            Cancel
          </button>
          <button type="button" className="btn btn--primary" onClick={onConfirm} disabled={printing}>
            {printing ? "Printing…" : `Print ${checkCount(count)}`}
          </button>
        </>
      }
    >
      <p className="print-checks-dialog__question">Print {checkCount(count)}?</p>
      <p className="print-checks-dialog__total">
        Total <span className="print-checks-dialog__money-total">{formatMoney(total)}</span>. Each gets the next
        check number, oldest payment first.
      </p>
    </DialogShell>
  );
}
